import { type LensSubmissionType, type LensstudioMylensesSubmit } from "@snapchat/blizzard-schema";

import { type LensStudioAnalytics } from "../../gql-generated/types";

export interface SubmitEventData {
    event: LensstudioMylensesSubmit["event_name"];
    analytics: LensStudioAnalytics;
    lensId: string;
    lensSubmissionType: LensSubmissionType;
}

export const createSubmitEvent = ({
    event,
    analytics,
    lensId,
    lensSubmissionType,
}: SubmitEventData): LensstudioMylensesSubmit => ({
    event_name: event,
    lens_id: lensId,
    lens_type: lensSubmissionType,
    app_session_id: analytics.appSessionId,
    installation_id: analytics.installationId,
    document_id: analytics.documentId,
    original_document_id: analytics.originalDocumentId,
    gpu_opengl_version: analytics.gpuOpenglVersion,
    gpu_family: analytics.gpuFamily,
    gpu_vendor: analytics.gpuVendor,
    lensstudio_version: analytics.appVersion,
    lensstudio_build: analytics.appBuild,
    lensstudio_os_type: analytics.osType,
    lensstudio_os_version: analytics.osVersion,
});
